import { Pagination } from "./pagination.model";

export class ActivePagination implements Pagination {

  public o: number;
  public l: number;
  public sn: string | undefined;
  public c: { key: string, value: string }[];
  public s: { key: string, value: 'ASC' | 'DESC' }[];

  constructor(
    offset: number = 0,
    limit: number = 100,
    conditions: { key: string, value: string }[] = [],
    sorts: { key: string, value: 'ASC' | 'DESC' }[] = [],
    snapshot?: string
  ) {
    this.l = limit;
    this.s = sorts;
    this.o = offset;
    this.sn = snapshot;
    this.c = conditions;

    this.c.push({ key: 'status', value: 'ACTIVE' });
  }

  public toString(): string{
    let str: string = `limit=${ this.l }&offset=${ this.o }&${ this.c.map(s => `${ s.key }=${ s.value }`).join('&') }`;
    if (this.sn) str += `&snapshot=${ this.sn }`;
    if (this.s.length > 0) str += '&' + this.s.map(s => `orderBy=${ s.key }&order=${ s.value }`).join('&');
    return str;
  }
}
